import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-date-picker";
import moment from "moment";
import Crop from "../../shared/crop";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const Add = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState("");
  const [sizeDrp, setSizeDrpData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [productDrp, setProductDrpData] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState();
  const [formData, setFormData] = useState({
    name: "",
    size_id: "",
    product_id: "",
    price: "",
    image: "",
    weight: "",
    opening_stock: "",
    opening_stock_date: null,
    image_url: "",
  });

  const getProductData = () => {
    axios.post(API_URL.PRODUCT_ONLY, {}).then((res) => {
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.category?.name + ' - ' + caw.name,
          value: caw.id,
          size_id: caw.size_id,
          weight: caw.weight,
          price: caw.price,
        };
      });
      setProductDrpData(cd);
    });
  };

  const getSizeData = () => {
    axios.post(API_URL.SIZE_LIST, {}).then((res) => {
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setSizeDrpData(cd);
    });
  };


  const onSave = () => {
    if (
      formData.name &&
      formData.size_id &&
      formData.weight &&
      formData.price &&
      formData.product_id &&
      (id ? true : formData.image)
    ) {
      setError(false);
      setLoading(true);

      let payload = { ...formData };
      if (invoiceDate) {
        payload.opening_stock_date = moment(invoiceDate).format("YYYY-MM-DD");
      } else {
        payload.opening_stock_date = null;
      }

      const pUrl = id ? API_URL.SUB_PRODUCT_UPDATE : API_URL.SUB_PRODUCT_SAVE;
      axios
        .post(pUrl, payload)
        .then((res) => {
          if (res.data.status === 1) {
            let message = id
              ? "Sub Product Updated Successfully."
              : "Sub Product Created Successfully.";
            toast.success(message, { autoClose: 3000, position: "top-right" });
            setLoading(false);
            navigate("/product/sub-product");
          } else {
            toast.info(res.data.data, { autoClose: 3000, position: "top-right" });
            setLoading(false);
          }
        })
        .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.SUB_PRODUCT_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          product_id: res.data.data.product_id ? res.data.data.product_id : "",
          weight: res.data.data.weight ? res.data.data.weight : "",
          price: res.data.data.price ? res.data.data.price : "",
          size_id: res.data.data.size_id ? res.data.data.size_id : "",
          opening_stock: res.data.data.opening_stock ? res.data.data.opening_stock : "",
          opening_stock_date: null,
          image: ""
        });
        if (res.data.data.image) {
          setImagePreview(res.data.data.image);
        }
        if (res.data.data.opening_stock_date) {
          setInvoiceDate(new Date(res.data.data.opening_stock_date));
        }
      }
    });
  };

  const isRequiredField = (key) => {
    return isError && !formData[key];
  };

  useEffect(() => {
    getSizeData();
    getProductData();
  }, []);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} SubProduct</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/product/sub-product"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Image<span className="required-star">*</span></label>
                      <div
                        className={isRequiredField("image") && "required-box"}
                      >
                        <Crop
                          imagePreview={imagePreview}
                          cropShape={"round"}
                          guid={""}
                          width={250}
                          height={250}
                          onChangeCropper={async ({
                            fileCroppedBase64,
                          }) => {
                            setFormData({
                              ...formData,
                              image: fileCroppedBase64,
                            });
                            setImagePreview(fileCroppedBase64);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="Product">Product<span className="required-star">*</span></label>
                          <Select
                            options={productDrp}
                            placeholder=""
                            value={productDrp.find(
                              (r) => r.value == formData.product_id
                            )}
                            styles={
                              isRequiredField("product_id")
                                ? customRequireStyles
                                : customStyles
                            }
                            onChange={(e) =>
                              setFormData({ ...formData, product_id: e.value, size_id: e.size_id, weight: e.weight, price: e.price })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Name<span className="required-star">*</span></label>
                          <input
                            type="text"
                            name="name"
                            maxLength={30}
                            value={formData.name}
                            className={
                              isRequiredField("name")
                                ? "form-control required"
                                : "form-control"
                            }
                            id="name"
                            onChange={(event) => {
                              setFormData({ ...formData, name: event.target.value });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="Size">Size</label>
                          <Select
                            options={sizeDrp}
                            placeholder=""
                            value={sizeDrp.find((r) => r.value == formData.size_id)}
                            onChange={(e) =>
                              setFormData({ ...formData, size_id: e.value })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Weight<span className="required-star">*</span></label>
                          <input
                            type="text"
                            name="name"
                            maxLength={30}
                            value={formData.weight}
                            className={
                              isRequiredField("weight")
                                ? "form-control required"
                                : "form-control"
                            }
                            id="weight"
                            onChange={(event) => {
                              setFormData({
                                ...formData,
                                weight: event.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Price<span className="required-star">*</span></label>
                          <input
                            type="number"
                            name="name"
                            maxLength={30}
                            value={formData.price}
                            className={
                              isRequiredField("price")
                                ? "form-control required"
                                : "form-control"
                            }
                            id="price"
                            onChange={(event) => {
                              setFormData({ ...formData, price: event.target.value });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Opening Stock</label>
                          <input
                            type="text"
                            name="opening_stock"
                            maxLength={30}
                            value={formData.opening_stock}
                            className="form-control" id="opening_stock"
                            onChange={(event) => {
                              setFormData({...formData, opening_stock: event.target.value });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="">Opening Stock Date</label>
                          <DatePicker
                            format={"dd/MM/y"}
                            className="form-control"
                            onChange={setInvoiceDate}
                            value={invoiceDate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group text-right">
                      <button
                        type="submit"
                        onClick={onSave}
                        disabled={ loading}
                        className="btn btn-primary"
                      >
                        {loading ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Watch color={"white"} height={20} width={20} />
                          </div>
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Add;
